import classNames from "classnames";
import { DescriptionBlock } from "@/pages/quiz/15000/components/QuestionContentDisplay/components/DescriptionBlock";
import { QuestionDescriptionBlock } from "@/types";
import { clsxm } from "@/utils/clsxm";

interface IProps {
  question?: string;
  prompt?: string;
  customHTML?: string;
  descriptionBlock?: QuestionDescriptionBlock;
}

// Replaces normal hyphens "-" (U+002D) with non-breaking hyphens (U+2011).
// Prevents browsers (especially Chrome) from breaking words.
const noBreakHyphens = (value: string) => value.replace(/-/g, "\u2011");

const QuestionContentDisplay = ({
  question,
  prompt,
  customHTML,
  descriptionBlock,
}: IProps) => (
  <div className="mb-4 sm:mb-4 space-y-4">
    <h2
      className={clsxm(
        "text-4xl mb-6 text-new-design-gray-500 font-medium whitespace-normal break-keep hyphens-none"
      )}
    >
      {noBreakHyphens(question ?? "")}
    </h2>

    {prompt && (
      <p className="text-base text-new-design-gray-500/50">{prompt}</p>
    )}

    {customHTML && (
      <div
        className="text-base text-new-design-gray-500/50"
        dangerouslySetInnerHTML={{ __html: customHTML }}
      />
    )}

    {(descriptionBlock || [])?.map((props) => (
      <DescriptionBlock {...props} />
    ))}
  </div>
);

export { QuestionContentDisplay };
